module.exports = __webpack_public_path__ + "media/images/static/top/local/photo5_mobile-e9affe0af6462e48c9df446a1cbd58ed.png";